import React from 'react'
import { Div } from '@nic/ui-comps'

interface DashboardSectionTitleProps {
  label: string
  icon?: React.ReactNode
}

export const DashboardSectionTitle: React.FC<DashboardSectionTitleProps> = ({ label, icon }) => {
  return (
    <Div className="dashboard-section-label">
      {icon && <span className="dashboard-section-icon">{icon}</span>}
      <span>{label}</span>
    </Div>
  )
}
